// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coming-soon[data-v-7abf9358]{display:flex;justify-content:center;align-items:center;height:100vh;background-color:#f5f5f5;color:#333;text-align:center}.content[data-v-7abf9358]{max-width:500px;margin:auto}h1[data-v-7abf9358]{font-size:3rem;margin-bottom:1rem}p[data-v-7abf9358]{font-size:1.2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
